import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { API_URL, getCachedSessionId } from '../../services/common';
import { useNotification } from '../../providers/notificationsProvider';

const refreshDomain = async ({ projectId, domainId }) => {
  const response = await axios.post(
    `${API_URL}/v1/project/${projectId}/provider/domain/${domainId}/refresh`,
    {},
    { headers: { 'x-session-id': getCachedSessionId() } }
  );

  return response.data;
};

export const useRefreshDomain = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotification();
  return useMutation(refreshDomain, {
    onError: (error) => {
      notify({ message: error.message, severity: 'error' });
    },
    onSuccess: () => {
      notify({ message: 'Domain was refreshed successfully', severity: 'success' });
      queryClient.invalidateQueries(['domains']);
    }
  });
};
